import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { AbsenceSalarieDto } from "../../../../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { EtatAbsencesEnum } from "../../../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { ParametresInstance } from "../../../../../Controls/Parameters";
import DataTestIDHelper from "../../../../../../Helper/DataTestID/DataTestIDHelper";

@Component
export default class TableauAnnulation extends Vue {
	@Prop()
	public absencesAnnulation: AbsenceSalarieDto[] = [];

	public AnnulerAnnulationAbsence(absence: AbsenceSalarieDto): void {
		this.$emit("AnnulerAnnulationAbsence", absence);
	}

	public getLibelleEtat(absence: AbsenceSalarieDto): string {
		let libelleEtat = ParametresInstance.getLibelleEtatAbsence(absence.Etat)
		return libelleEtat[0].toUpperCase() + libelleEtat.slice(1);
	}

	public estEnAttenteValidationAnnulation(absence: AbsenceSalarieDto): boolean {
		return absence.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1 || absence.Etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2;
	}

	public getAnnulationRequestEntryDataTestID(absence: AbsenceSalarieDto, suffix: string): string {
		return DataTestIDHelper.getAbsenceRequestDataTestID(absence.LibelleTypeAbsence, absence.DateDebut, absence.DateFin, "salarie-annulationList-", suffix);
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/listeDesDemandes/espaceSalarie/tableaux/tableauAnnulation/tableauAnnulation.ts